import { DisbursementAdviceActionDispatch, DisbursementAdviceReduxTypes } from "./types";

export const createDisbursementAdvice = (payload: any): DisbursementAdviceActionDispatch => ({
  type: DisbursementAdviceReduxTypes.DISBURSEMENT_ADVICE_REPORT,
  payload: payload
});
